import { cn } from '@discover-lib/utils';
import Button, { type ButtonProps } from '@discover-ui/button';
import ChevronLeft from '@discover-ui/icons/chevron-left.svg';

export type BackButtonProps = Omit<ButtonProps, 'children'>;

export default function BackButton({ className, ...props }: BackButtonProps) {
  return (
    <Button
      key="back-button"
      className={cn(
        'flex aspect-square w-full flex-col items-center justify-center p-2',
        className
      )}
      {...props}>
      <ChevronLeft className="size-6" />
    </Button>
  );
}
